import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides construction cleaning near me?',
    a: 'Quiroz Construction Cleaning provides professional post-construction cleaning services in Las Vegas, helping contractors and property owners prepare spaces for final walkthroughs, inspections, and occupancy with detailed and reliable cleaning.',
  },
  {
    q: 'How much does construction cleaning cost?',
    a: 'Pricing depends on project size, scope, and level of cleaning required. Post-construction cleaning can vary based on debris removal, detailing, and timeline. The best approach is to request a quote based on your specific project needs.',
  },
  {
    q: 'How long does construction cleaning take?',
    a: 'Timeline depends on the size and condition of the project. Smaller jobs may be completed quickly, while large construction sites may require multiple phases of cleaning to ensure everything is fully detailed and move-in ready.',
  },
  {
    q: 'What is included in post-construction cleaning?',
    a: 'Our post-construction cleaning includes debris removal, dust and drywall particle cleanup, surface wiping, window cleaning, floor cleaning, and a final detail pass — everything needed to make the space ready for occupancy or final inspection.',
  },
  {
    q: 'Do you work with general contractors in Las Vegas?',
    a: 'Yes. We work directly with general contractors, builders, and developers across Las Vegas. We coordinate around your build schedule and deliver cleaning at the right phase — rough clean, final clean, or both.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="bg-[#f5f4f0] py-24 px-6 md:px-16 lg:px-24">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
        <div className="lg:col-span-2">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-px bg-[#C9A84C]"></div>
            <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">FAQ</span>
          </div>
          <h2 className="font-barlow-condensed font-900 text-[#1a1a1a] text-4xl md:text-5xl leading-none mb-6">
            COMMON<br />QUESTIONS<br /><span className="text-[#C9A84C]">ANSWERED</span>
          </h2>
          <p className="font-inter text-[#1a1a1a]/55 text-sm leading-relaxed">
            Everything you need to know about post-construction cleaning and commercial cleaning services in Las Vegas.
          </p>
        </div>
        <div className="lg:col-span-3 flex flex-col gap-2">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-sm overflow-hidden">
              <button
                onClick={() => setOpen(open === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="font-barlow font-700 text-[#1a1a1a] text-sm pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`text-[#C9A84C] text-base transition-transform duration-200 ${open === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {open === idx && (
                <div className="px-6 pb-5">
                  <p className="font-inter text-[#1a1a1a]/60 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
